import { render, staticRenderFns } from "./NotificationConfigPanel.vue?vue&type=template&id=43bf466a&scoped=true"
import script from "./NotificationConfigPanel.vue?vue&type=script&lang=js"
export * from "./NotificationConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfigPanel.vue?vue&type=style&index=0&id=43bf466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf466a",
  null
  
)

export default component.exports